import React from 'react'
import PropTypes from 'prop-types'
import './room-header.scss'
import cn from "classnames";


const RoomHeader = ({
  title, removeAnchor, roomsCount, roomId, onRemoveClick,
}) => (
  <div className={cn('filter-rooms__room-header', (roomsCount > 1) && 'more-then-one')}>
    <div className="filter-rooms__room-header__title">
      {title}
    </div>
    {roomsCount > 1
    && (
    <div className="filter-rooms__room-header__remove-link" onClick={onRemoveClick(roomId)}>
      {removeAnchor}
    </div>
    )}
  </div>
)

RoomHeader.propTypes = {
  title: PropTypes.string.isRequired,
  removeAnchor: PropTypes.string.isRequired,
  roomsCount: PropTypes.number.isRequired,
  roomId: PropTypes.string.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
}

export default RoomHeader
